import { forwardRef } from "react";

import AppIconButton, { AppIconButtonProps } from "../Button/AppIconButton";

export const ToolbarIconButton = forwardRef<HTMLButtonElement, AppIconButtonProps>(
  function ToolbarIconButton(props: AppIconButtonProps, ref) {
    return <AppIconButton ref={ref} variant='text' color='text' {...props} />;
  },
);
